import MDBox from "components/Basics/MDBox";
import { Card, CardContent, Divider, Icon } from "@mui/material";
import MDTypography from "components/Basics/MDTypography";
import i18n from "i18n";
import { useSelector, useDispatch } from "react-redux";
import FaiqActions from "redux-react/actions/faiqActions";
import MDInput from "components/Basics/MDInput";
import MDButton from "components/Basics/MDButton";
import { display } from "redux-react/reducers/snackBarReducer";
import { t } from "i18next";

const IntegrationPart = ({ copySetting, setCopySetting, settings, setSettings }) => {
	const { profile } = useSelector(state => state);
	const dispatch = useDispatch();

	const hideApiKey = apiKey => {
		return `${apiKey.substring(0, 5)}XXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX`;
	};

	const refreshApiKey = () => {
		dispatch(
			FaiqActions.refreshFaiqApiKey(profile.assistantID, res => {
				setSettings({
					...settings,
					apiKey: res.apiKey
				});

				setCopySetting({
					...copySetting,
					apiKey: res.apiKey
				});
			})
		);
	};

	return (
		<>
			<MDBox mt={3} mb={3}>
				<MDTypography variant="h3">{i18n.t("CONFIG.integration")}</MDTypography>
			</MDBox>

			<MDBox mt={3}>
				<Card>
					<CardContent>
						{/* API Key */}
						<MDBox mt={2}>
							<MDTypography variant="h6">{i18n.t("CONFIG.apiKey")}</MDTypography>
							<MDBox display="flex" alignItems="stretch">
								<MDButton
									color="info"
									variant="gradient"
									sx={{ mr: 1 }}
									onClick={() => {
										navigator.clipboard.writeText(settings.apiKey);
										dispatch(
											display({
												type: "info",
												message: i18n.t("CONFIG.DISPLAY.copiedApiKey")
											})
										);
									}}
								>
									<Icon>copy</Icon>&nbsp;{i18n.t("SETTINGS.copy")}
								</MDButton>

								<MDInput
									disabled
									className="dialogInput"
									value={hideApiKey(settings.apiKey)}
								></MDInput>

								<MDButton color="info" variant="gradient" sx={{ ml: 1 }} onClick={refreshApiKey}>
									<Icon>replay</Icon>&nbsp;{i18n.t("CONFIG.regenerate")}
								</MDButton>
							</MDBox>
						</MDBox>
						{/* Wordpress */}
						<MDBox mt={3}>
							<MDTypography variant="h6">{i18n.t("CONFIG.wordpress")}</MDTypography>
							<MDBox display="flex" alignItems="center" justifyContent="space-between">
								<MDTypography variant="body2" flex="8">
									{i18n.t("CONFIG.downloadWordpressPlugin")}
								</MDTypography>

								<MDButton
									color="info"
									variant="gradient"
									sx={{ ml: 1, flex: 1 }}
									onClick={() => {
										window.open(settings.wordpressPlugin, "_blank");
									}}
									disabled={!settings.wordpressPlugin}
								>
									<Icon>download</Icon>&nbsp;{i18n.t("CONFIG.download")}
								</MDButton>
							</MDBox>
						</MDBox>
						{/* API Doc */}
						<MDBox mt={3}>
							<MDTypography variant="h6">{t("CONFIG.seeApiDocTitle")}</MDTypography>
							<MDBox display="flex" alignItems="center" justifyContent="space-between">
								<MDTypography variant="body2" flex="8">
									{t("CONFIG.seeApiDocDescription")}
								</MDTypography>

								<MDButton
									color="info"
									variant="gradient"
									sx={{ ml: 1, flex: 1 }}
									onClick={() => {
										window.open(settings.apiDoc, "_blank");
									}}
									disabled={!settings.apiDoc}
								>
									<Icon>description</Icon>&nbsp;{t("SETTINGS.see")}
								</MDButton>
							</MDBox>
						</MDBox>
						{/* Hash for static server */}
						<Divider />
						<MDBox mt={3}>
							<MDTypography variant="h6">
								Clé d&apos;identification pour les liens des assets.
							</MDTypography>
							<MDInput
								className="dialogInput"
								value={settings.staticServerHash || ""}
								placeholder="Entrez une clé personnalisée"
								onChange={e => {
									const newHash = e.target.value;
									// Simple validation: no space, no special char, only - and _
									if (!/^[a-zA-Z0-9-_]*$/.test(newHash)) {
										dispatch(
											display({
												type: "error",
												message: i18n.t("CONFIG.DISPLAY.invalidStaticServerHash")
											})
										);
										return;
									}
									// Update settings
									setSettings({
										...settings,
										staticServerHash: newHash
									});
								}}
							></MDInput>
							<MDBox mt={1} p={2} sx={{ backgroundColor: "#f5f5f5", borderRadius: 1 }}>
								<MDTypography variant="caption" color="textSecondary">
									Votre clé apparaitra dans les liens de vos assets comme ceci:
								</MDTypography>
								<MDTypography
									variant="body2"
									sx={{ fontFamily: "monospace", wordBreak: "break-all" }}
								>
									<span>https://documents.faibrikplatform.com/</span>
									<span
										style={{
											fontWeight: "bold",
											color: "#1976d2"
										}}
									>
										{settings.staticServerHash || "votre-clé-personnalisée"}
									</span>
									<span>/8be21b305e0...</span>
								</MDTypography>
							</MDBox>
						</MDBox>
					</CardContent>
				</Card>
			</MDBox>
		</>
	);
};

export default IntegrationPart;
